module.exports = __webpack_public_path__ + "img/geofisica_9-16_1620.65548ed3.jpg";